import React from 'react';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { STATIC_ROOT } from '../../../../constants';

import { hideModal } from '../../../../services/modal/actions';
import {
    sendIbanDeleteRequest,
    reset,
    setTimeoutId
} from '../../../../services/account/iban/actions';

import { convertHtmlToReactDomWithParams } from '../../../../utils/htmlUtils';

import SvgComponent from '../../../SvgComponent';
import ButtonComponent from '../../../button/ButtonComponent';
import { LoadingComponent } from '../../../loading/LoadingComponent';

import './DeleteIbanModalComponent.scss';

class DeleteIbanModalComponent extends React.Component {
    componentWillMount() {
        const { reset, timeoutId } = this.props;

        clearTimeout(timeoutId);
        reset();
    }

    componentDidUpdate() {
        const { hideModal, deleteIbanSuccess } = this.props;

        if (deleteIbanSuccess) {
            hideModal();
        }
    }

    submit = () => {
        const { sendIbanDeleteRequest, iban, timeoutId } = this.props;

        clearTimeout(timeoutId);

        sendIbanDeleteRequest(iban.id);
    };

    abortDelete = () => {
        const { hideModal } = this.props;
        hideModal();
    };

    renderIbanLabel = iban => {
        const { i18n } = this.props;

        if (iban.label) {
            return iban.label;
        } else if (iban.firstname || iban.lastname) {
            const name = `${iban.firstname ? iban.firstname : ''} ${
                iban.lastname ? iban.lastname : ''
            }`;
            return convertHtmlToReactDomWithParams(i18n.ACCOUNT_OF, name);
        } else {
            return iban.iban;
        }
    };

    render() {
        const { i18n, iban, deleteIbanFetching, errorSubmit, deleteIbanError } = this.props;

        return (
            <div className="modal-delete-iban">
                <div className="container-header">
                    {convertHtmlToReactDomWithParams(
                        i18n.DELETE_MODAL_HEADER,
                        this.renderIbanLabel(iban)
                    )}
                </div>
                <div className="container-body">
                    <p className="title">
                        {convertHtmlToReactDomWithParams(i18n.DELETE_MODAL_TEXT_1)}
                    </p>
                    <p>
                        {convertHtmlToReactDomWithParams(i18n.DELETE_MODAL_TEXT_2, iban.lastname)}
                    </p>
                    <p>
                        {convertHtmlToReactDomWithParams(i18n.DELETE_MODAL_TEXT_3, iban.firstname)}
                    </p>
                    <p>{convertHtmlToReactDomWithParams(i18n.DELETE_MODAL_TEXT_4, iban.iban)}</p>
                    {iban.bic && (
                        <p>{convertHtmlToReactDomWithParams(i18n.DELETE_MODAL_TEXT_5, iban.bic)}</p>
                    )}
                    <div className="container-button">
                        <ButtonComponent
                            id="delete-abort"
                            color="second"
                            text={i18n.DELETE_MODAL_CTA_ABORT}
                            onClick={this.abortDelete}
                        />
                        <ButtonComponent
                            id="delete-ok"
                            type="submit"
                            color="main"
                            text={i18n.DELETE_MODAL_CTA_CONFIRM}
                            onClick={this.submit}
                        />
                        {deleteIbanFetching && <LoadingComponent />}
                    </div>
                    {errorSubmit && (
                        <div role="alert" className="form-input-legend color-err err-picto">
                            <div className="picto">
                                <SvgComponent
                                    src={`${STATIC_ROOT}/picto-errors.svg`}
                                    width={20}
                                    height={20}
                                    aria-hidden="true"
                                />
                            </div>
                            <div>{deleteIbanError}</div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

DeleteIbanModalComponent.propTypes = {
    iban: PropTypes.object
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.page.ACCOUNT.PROFILE.IBAN,
        deleteIbanSuccess: state.account.iban.deleteIbanSuccess,
        deleteIbanFetching: state.account.iban.fetching,
        deleteIbanError: state.account.iban.deleteIbanError || '',
        errorSubmit: !isEmpty(state.account.iban.deleteIbanError),
        timeoutId: state.account.iban.resetTimeoutId
    };
};

const mapDispatchToProps = {
    hideModal,
    sendIbanDeleteRequest,
    reset,
    setTimeoutId
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteIbanModalComponent);



// WEBPACK FOOTER //
// ./src/components/pages/account/myprofile/DeleteIbanModalComponent.js